import { IinventoryManagement } from "../../types/inventory-management.type";
import {
  ApiResponseType,
  downloadRequest,
  makeRequest,
} from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}/inventory-management`;

const makeRequestDebounced = createDebounce(makeRequest, 200);
export const getInventoryManagementPaged = async ({
  search = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "-updatedAt",
  fields = "_id, assetCode, description, category, companyId, departmentEnum, acquisitionDate, acquisitionValue, residualValue, depreciationRate, netValue, usefulLifeInMonths, currentStatus, fiscalIncentive, icmsCreditable, pisCofinsRate, taxRegime, invoiceKey, invoiceDocumentPath, lastInventoryDate, inventoryStatus, physicalTagPresent, notes, employeerId, createdAt, updatedAt, deleteAt, createdBy, serieNumber, signedDocumentPath, documentStatus",
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  params.append("filters[deleteAt]", "null");

  const url = `${API_URL}/paged?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IinventoryManagement[]
  > & { totalItems: number; page: number };
  return {
    ok: result.ok,
    data: result.data,
    totalItems: result.totalItems,
    page: result.page,
    message: result.message,
  };
};

export const createInventoryManagement = async (
  data: Partial<IinventoryManagement>,
) => {
  const url = `${API_URL}/create`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IinventoryManagement>
  >;
};

export const uploadSignedDocumentInventoryManagement = async (data: {
  inventoryId: string;
  file: string;
  fileName: string;
}) => {
  const url = `${API_URL}/upload_signed_document`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IinventoryManagement>
  >;
};

export const downloadSignedDocument = async (
  inventoryId: string,
): Promise<void> => {
  try {
    const endpoint = `${API_URL}/download_signed_document/${inventoryId}`;
    const result = await downloadRequest(endpoint);

    if (!result.ok || !result.data) {
      console.error(result.message || "Erro ao baixar documento");
      return;
    }

    const blob = result.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${inventoryId}.pdf`);

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err: unknown) {
    console.error(err);
  }
};

export const updateInventoryManagement = async (
  data: Partial<IinventoryManagement>,
) => {
  const url = `${API_URL}/update`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IinventoryManagement>
  >;
};

const makeRequestDeleteFile = createDebounce(makeRequest, 200);
export const inventoryManagementDeleteFile = async (
  data: Partial<IinventoryManagement>,
) => {
  const url = `${API_URL}/update`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return (await makeRequestDeleteFile(url, options)) as Promise<
    ApiResponseType<IinventoryManagement>
  >;
};

const makeRequestSendFile = createDebounce(makeRequest, 200);
export const inventoryManagementSendFile = async (
  data: Partial<IinventoryManagement>,
) => {
  const url = `${API_URL}/update`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return (await makeRequestSendFile(url, options)) as Promise<
    ApiResponseType<IinventoryManagement>
  >;
};

export const deleteInventoryManagement = async (
  inventoryManagementId: string,
) => {
  const url = `${API_URL}/delete/${inventoryManagementId}`;
  const options = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };

  return (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IinventoryManagement>
  >;
};